<template>
  <d-card class="card-small mb-3">
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ $t('fences.card.actions') }}</h6>
    </d-card-header>

    <d-card-body class="px-0">
      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-button
            :disabled="!canExport"
            @click.prevent="toggleModal()"
            class="btn-dark btn-block"
          >
            {{ $t('shared.actions.export') }}
          </d-button>

          <p
            v-if="!canExport"
            class="text-muted mb-1 small"
            style="color: #6c757d !important"
          >
            {{ $t('fences.sidebar.exportHint') }}
          </p>

          <d-button
            @click.prevent="generate()"
            :disabled="canGenerate"
            class="btn-outline-dark btn-block"
          >
            {{ $t('fences.button.generate') }}
          </d-button>
        </d-list-group-item>
      </d-list-group>
    </d-card-body>
    <d-card-footer
      class="border-top d-flex flex-column flex-xl-row justify-content-around"
    >
      <d-button
        @click="save"
        type="button"
        class="btn-primary mb-3 mb-xl-0 col-xl-5"
      >
        {{ $t('shared.actions.save') }}
      </d-button>
      <d-button class="btn-secondary text-white col-xl-5" @click="goBack">
        {{ $t('shared.actions.back') }}
      </d-button>
    </d-card-footer>

    <export-file-modal
      gameType="fences"
      :items="[model]"
      :fileName="model.name || $t('fences.sidebar.defaultFileName')"
    />
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import ExportFileModal from '_common/shared/ExportFileModal.vue';
import { MODEL } from './PuzzleFencesModel';

export default {
  name: 'sidebar-actions',
  props: {
    model: {
      type: Object,
      default: () => MODEL,
    },
  },
  components: { ExportFileModal },
  computed: {
    canExport() {
      const { hasChanges } = this.$store.state.fences;
      const isPageCreation = !this.$route.params.puzzleId;

      if (isPageCreation) return false;
      if (hasChanges) return false;

      return true;
    },
    canGenerate() {
      const { enableExport } = this.$store.state.fences;

      return enableExport;
    },
  },
  methods: {
    ...mapActions(['setToggle']),
    goBack() {
      this.$router.go(-1);
    },
    generate() {
      this.$emit('generate', this.model);
    },
    save() {
      this.$emit('save', this.model);
    },
    toggleModal() {
      this.setToggle({ type: 'export_file_modal', bool: true });
    },
  },
};
</script>
